/** In-memory snapshot for non-React callers (API helpers). Synced by OktaSessionProvider. */
let snapshot = { orgUrl: null, apiToken: null };

export function setOktaSessionSnapshot(next) {
  snapshot = {
    orgUrl: next?.orgUrl ?? null,
    apiToken: next?.apiToken ?? null,
  };
}

export function getOktaSessionSnapshot() {
  return snapshot;
}
